import React from 'react';
import { Alert } from '@acpaas-ui/react-components';

export const ErrorToastAlert = ({ message, closeToast }) => (
  <Alert type="danger" title="Opgelet" onClose={closeToast} closable>
    {message}
  </Alert>
);

export const SuccessToastAlert = ({ message, closeToast }) => (
  <Alert
    type="success"
    title="Success"
    onClick={() => {
      closeToast();
    }}
    onClose={() => {
      closeToast();
    }}
    closable
  >
    {message}
  </Alert>
);

export const InfoToastAlert = ({ message, closeToast }) => (
  <Alert type="primary" title="Informatie" onClose={closeToast} closable>
    {message}
  </Alert>
);

export const WarningToastAlert = ({ message, closeToast }) => (
  <Alert type="warning" title="Opgelet" onClose={closeToast} closable>
    {message}
  </Alert>
);
